import { el } from '../utils/dom.js';

export function toast(message, kind = 'info', timeout = 3500) {
  const root = document.getElementById('toast-root');
  if (!root) return;
  const node = el('div', { class: `toast ${kind}` }, message);
  root.appendChild(node);
  setTimeout(() => {
    node.style.transition = 'opacity .25s, transform .25s';
    node.style.opacity = '0';
    node.style.transform = 'translateX(20px)';
    setTimeout(() => node.remove(), 300);
  }, timeout);
}

export const ok    = (m) => toast(m, 'success');
export const err   = (m) => toast(m, 'error');
export const info  = (m) => toast(m, 'info');
